import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetWageSupplementTerms,
  SaveWageSupplementTerms,
  GetWageSupplementToCompensateYearTypes,
  GetWageSupplementDayoffromhourTypes,
  GetWageSupplementDayoftohourTypes,
  GetWageSupplementTermTypes
};


function GetWageSupplementTerms(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/wagesupplementterm`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function SaveWageSupplementTerms(
  wageSupplementTypeConfigurationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/wagesupplementterm`,
      wageSupplementTypeConfigurationObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetWageSupplementDayoffromhourTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/enumlist/dayoffromhour`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWageSupplementToCompensateYearTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/enumlist/tocompensateyeartypes`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWageSupplementDayoftohourTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/enumlist/dayoftohour`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}

function GetWageSupplementTermTypes(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/enumlist/wagesupplementtermtype`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        onError(error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        onError(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error;
        onError(error.message);
      }
      onError(error.config);
    });
}
